import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f96f37fa")

_pushScopeId("data-v-f96f37fa")
const _hoisted_1 = { class: "input__pharmacy" }
const _hoisted_2 = { class: "select-pharmacy" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  class: "-pc -medium",
  for: "pharmacyList"
}, "약국선택", -1)
const _hoisted_4 = {
  key: 0,
  class: "-mobile -medium",
  for: "pharmacyList"
}
const _hoisted_5 = { class: "pharmacy-item" }
const _hoisted_6 = { class: "p-ml-2" }
const _hoisted_7 = { style: {"font-size":"0.7rem"} }
const _hoisted_8 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.selectedPharmacy)
        ? (_openBlock(), _createBlock("label", _hoisted_4, "약국선택"))
        : _createCommentVNode("", true),
      _createVNode(_component_AutoComplete, {
        id: "pharmacyList",
        modelValue: _ctx.selectedPharmacy,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedPharmacy = $event)),
        suggestions: _ctx.pharmacies.filteredPharmacy,
        onComplete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchPharmacy($event))),
        dropdown: true,
        field: "PharmacyName",
        forceSelection: "",
        class: "pharmacy__list",
        onItemSelect: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectItem($event))),
        disabled: _ctx.state.requestStatus > _ctx.RequestStatuses.Requested
      }, {
        item: _withId((slotProps) => [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, _toDisplayString(slotProps.item.PharmacyName), 1),
            _createVNode("div", _hoisted_7, _toDisplayString(`${slotProps.item.Address1} 
                        ${slotProps.item.Address2} 
                        ${slotProps.item.Address3} 
                        ${slotProps.item.Address4}`), 1)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "suggestions", "disabled"])
    ]),
    (_ctx.state.requestStatus <= _ctx.RequestStatuses.Requested)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          (_ctx.state.isDefault)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "pharmacy__default",
                onClick: _ctx.getMyDefulatPharmacyKey
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("default")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            class: "pharmacy--reset p-button-secondary",
            onClick: _ctx.selectedNull
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.t("PharmacyNone")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
})